import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-767">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-768">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-769">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-770">
          {isOpen ? <XIcon size={24} data-id="element-771" /> : <PlusIcon size={24} data-id="element-772" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-773">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-774">
          {answer}
        </p>
      </div>
    </div>;
}
export function CTFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'How Does CoolTone Work?',
    answer: 'CoolTone works by delivering electromagnetic energy to targeted muscles, inducing involuntary contractions that strengthen and tone the muscles, resulting in improved muscle conditioning and enhanced appearance.'
  }, {
    question: 'What Areas Can CoolTone Treat?',
    answer: 'CoolTone is designed to treat specific areas like the abdomen, buttocks and thighs, helping patients achieve firmer, more defined contours in these regions.'
  }, {
    question: 'Is It Painful?',
    answer: 'CoolTone treatments are generally well-tolerated, with minimal discomfort reported by most patients. Some may experience a sensation of intense muscle contractions during the procedure, but it is not typically described as painful.'
  }, {
    question: 'How Many Sessions Are Needed?',
    answer: 'The number of CoolTone sessions needed varies depending on individual goals and the area being treated. However, most patients typically undergo a series of 3-4 treatment sessions over several weeks to achieve optimal results.'
  }, {
    question: 'How Soon Can I See Results?',
    answer: 'While results may vary, many patients begin to notice improvements in muscle tone and definition as early as a few weeks after their initial CoolTone session. The most significant results are typically observed within a few months post-treatment.'
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-775">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-776">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-777">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-778">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-779"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-780">
          <div className="space-y-2" data-id="element-781">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-782" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}